import { makeAutoObservable } from "mobx";

export interface ISearchStore {
    searchText: string;
    typedSearchText: string;
    setTypedSearchText: (typedSearchText: string) => void;
    setSearchText: (searchText: string) => void;
}

export class SearchStore implements ISearchStore {
    searchText = "";
    typedSearchText = "";

    constructor() {
        makeAutoObservable(this);
    }

    setTypedSearchText(typedSearchText: string) {
        this.typedSearchText = typedSearchText;
    }

    setSearchText(searchText: string) {
        this.searchText = searchText;
    }

}
